var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard-layout"}},[_c('account-navigation-drawer'),_c('v-main',{staticClass:"d-block"},[_c('router-view')],1),_c('account-sidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }